import http from "lc-http";

const promotionalNoInterest = "Promotional No-Interest";
const promotionalRate = "Promotional Rate";

export const staticConstants = {
  PAYMENT_DETAILS_PROMOTIONAL_NO_INTEREST: {
    displayName: "Suggested Payment Details",
  },
  INSTALLMENT_LOAN: {
    displayName: "Fixed Rate Plan",
    pluralName: "Fixed Rate Plans",
  },
  INTEREST_FREE_LOAN: {
    displayName: `${promotionalNoInterest} Plan (Waived Interest, Payment Required)`,
    pluralName: `${promotionalNoInterest} Plans (Waived Interest, Payment Required)`,
  },
  PROMOTIONAL_RATE_LOAN: {
    displayName: `${promotionalRate} Plan (Low APR, Equal Payment Required)`,
    pluralName: `${promotionalRate} Plans (Low APR, Equal Payment Required)`,
  },
  ALL_PROMOTIONAL_PLANS: {
    displayName: "All Promotional Plans",
  },
  LC_PLANS: {
    displayName: "Installment Loans",
  },
  FIXED_RATE_PLAN: {
    displayName: "Fixed Rate Plan",
    pluralName: "Fixed Rate Plans",
  },
  PROMOTIONAL_RATE_PLAN: {
    displayName: `${promotionalRate} Plan (Low APR, Equal Payment Required)`,
    pluralName: `${promotionalRate} Plans (Low APR, Equal Payment Required)`,
  },
  PAYMENT_DETAILS_PROMOTIONAL_PLANS: {
    displayName: "Suggested Payment Details",
  },
  PROMOTIONAL_RATE: promotionalRate,
  PROMOTIONAL_NO_INTEREST: promotionalNoInterest,
  LC_TRUE_NO_INTEREST: {
    displayName: "0% APR",
  },
  LC_FIXED_RATE_PLAN: {
    displayName: "3.99% - 30.99% APR",
  },
  MA_min_amount: {
    value: 6001,
    text: "$6,001",
  },
  processStates: {
    APPLICATION_END: "ApplicationEnd",
    PENDING_IL: "PendingIL",
    SELECT_PLAN: "SelectPlan",
    ADS_INVESTIGATE: "AdsInvestigate",
  },
};

export const constantsSuccess = ({
  LC_FIXED_RATE_PLAN: { minRate, maxRate },
}) => ({
  ...staticConstants,
  LC_FIXED_RATE_PLAN: {
    displayName: `${minRate}% - ${maxRate}% APR`,
  },
});

export const getDynamicConstants = () =>
  http
    .get("/patientsolutions/app/payment-calculator/rates")
    .then((res) => res.data)
    .then(constantsSuccess);

export const submarkets = {
  DENTAL: "Dental/Orthodontics",
  FERTILITY: "Fertility",
  HAIR_RESTORATION: "Hair Restoration",
  WEIGHT_LOSS: "Weight Loss Surgery",
};

export const fertilityPharmaLab = {
  ARC: "LC-ARC-FERTILITY-PHARMA-LAB",
  NON_ARC: "LC-FERTILITY-PHARMA-LAB",
};

export const AjaxStatus = {
  Initial: 0,
  InProgress: 1,
  Success: 2,
  Error: 3,
};

